export default __webpack_public_path__ + "static/media/assets-fonts_00.acfb24a6.jpg";